export const environment = {
  production: false,
  apiUrl: 'https://api.irisdevs.com/api',
  turnadorTramitesUrl: 'https://turnos.irisdevs.com/#/tramites',
};
